<template>
  <v-container fluid fill-height>
    <v-layout flex align-center justify-center>
      <v-flex xs12 sm8>
        <v-card>
          <v-card-text>
              <v-container grid-list-lg>
                <v-layout row wrap>
                  <v-spacer></v-spacer>
                  <v-flex xs12 sm8>
                    <span class="themeGrey--text">
                      <h3 class="primary--text"> {{ nomeDoAutor() }}, </h3>
                      <br/>
                      <br/>
                      Sua solicitação número <span class="primary--text" style="font-weight:bold; font-size:110%;">{{ protocolo() }}</span> foi enviada com sucesso.
                      <br/>
                      <span v-if="!usuarioHelperComputed.USUARIO_LOGADO()">Em breve você receberá um e-mail com o link para realizar o cadastro da senha de acesso ao sistema Apisul Seguros.</span>
                      <br/>
                      <br/>
                      <span v-if="!usuarioHelperComputed.USUARIO_LOGADO()"> Enviaremos  e-mails informativos sobre o andamento da sua solicitação sempre que houver alteração de status.</span>
                      <span v-else> Você receberá e-mails informativos sobre o andamento da sua solicitação sempre que houver alteração de status.</span>
                    </span>  
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>
              </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-layout row wrap>
              <v-flex >
                <v-btn 
                  id="btnNovaCotacaoId" 
                  color="secondary" 
                  @click.native="go('Questionario')">
                    NOVA COTAÇÃO
                </v-btn>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex text-xs-right>
                <v-btn 
                  v-if="usuarioHelperComputed.USUARIO_LOGADO()"
                  id="btnSolicitacoesId"
                  @click.native="go('ListagemSolicitacoes')"
                  color="primary">
                    SOLICITAÇÕES
                </v-btn>
              </v-flex>
            </v-layout>
            <v-spacer></v-spacer>
          </v-card-actions>
          <br/>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import usuarioHelper from '@/helpers/usuario-logado';
import perfil from '@/helpers/perfil';

export default {
  name: 'QuestionarioFinalizado',
  computed: {
    usuarioHelperComputed: function() {
      return usuarioHelper;
    }
  },
  methods: {
    nomeDoAutor: function() {
      if(usuarioHelper.USUARIO_LOGADO()) {
        return usuarioHelper.USUARIO_LOGADO().perfil.id == perfil.COMERCIAL ? usuarioHelper.USUARIO_LOGADO().nome : this.$route.params.nome;
      }
      return this.$route.params.nome;
    },
    protocolo: function () {
      return this.$route.params.protocolo;
    },
    go: function(routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({name: routeName});
      } else {
        self.$router.push({name: routeName, params: routeParams});
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/questionario/QuestionarioFinalizado.vue